import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ReactSession } from 'react-client-session';
import styles from "./Global.module.css";

function SubscribeButton(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(0);
  const [subscribe, setSubscribe] = useState(false);
  ReactSession.setStoreType("localStorage");
  
  const logged_user = ReactSession.get("logged_user");

  if(logged_user) {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/check_subscribe.php`, {
      uid: logged_user,
      channel_uid: props.uid,
    },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    }).then(response => {
      setSubscribed(response.data.subscribed);

      if(response.data.is_subscribed === 0) {
        setSubscribe(false);
      }else if(response.data.is_subscribed === 1) {
        setSubscribe(true);
      }

      setLoading(true);
    }).catch(error => {
      console.log(error);
    })
  }

  const handleSubscribe = () => {
    if(logged_user) {
      axios.post(`${process.env.REACT_APP_API_URL}/api/user/subscribe.php`, {
        uid: logged_user,
        channel_uid: props.uid,
        type: 1
      },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }
      ).then(response => {
        if(response.data.title === "success") {
          if(response.data.text === "subscribed") {
            setSubscribe(true);
          }else if (response.data.text === "unsubscribed") {
            setSubscribe(false);
          }
        }
      }).catch(error => {
        console.log(error);
      })
    }else {
      navigate("/login");
    }
  }

  return (
      logged_user && props.uid === logged_user ? <Link to={`/dashboard/settings`}>
          <button className={`btn ${styles.subscribe} ${styles.btn_light} ${props.size && styles.btn_sm} text-uppercase`}>Settings</button>
        </Link>
        : <button className={`btn ${styles.subscribe} ${props.size && styles.btn_sm } ${subscribe && styles.btn_light}`} onClick={() => handleSubscribe()}>
          <i className="icon icon-plus"></i>{subscribe ? 'Subscribed' : 'Subscribe'} <span className="kcounter">{subscribed}</span>
        </button>
  );
}

export default SubscribeButton;